import PowerPurchaseAgreementTable from "components/charging/PowerPurchaseAgreementComponent/PowerPurchaseAgreementTable";
import UserContext from "Context/UserProvider";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { Box, CircularProgress } from '@mui/material';
import { useApiService } from "../../services/ApiService/ApiService";
import toast from 'react-hot-toast';

function PowerPurchaseAgreementListPage(props: any) {
    const { userInfo } = useContext(UserContext);
    const { fetchWithAuth } = useApiService();
    const [agreements, setAgreements] = useState([]);
    const [isError, setIsError] = useState(false);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    const fetchAgreements = async () => {
        try {
            const bodyData = {
                uuid: userInfo.uuid,
                businessUuid: userInfo.businessUuid
            };

            const response = await fetchWithAuth('/ppa/advanced/agreement/list/cpo', {
                method: 'POST',
                body: JSON.stringify(bodyData)
            });

            if (!response.ok) {
                throw new Error('Failed to fetch agreements');
            }

            const res_json = await response.json();

            console.log("SSS " + JSON.stringify(res_json));

            if (Array.isArray(res_json.agreements)) {
                setAgreements(res_json.agreements.map((e: any) => ({
                    ...e,
                    id: e.uuid,
                    businessName: e.businessName,
                    businessUuid: e.businessUuid,
                    rateCardName: e.rateCardName,
                    ppaPricePerKWh: e.ppaPricePerKWh,
                    startDate: e.startDate,
                    numberOfVehicles: e.numberOfVehicles,
                    monthlyCommitmentInKWh: e.monthlyCommitmentInKWh,
                    currentBalance: e.currentBalance,
                })));
            } else {
                setAgreements([]);  // If no agreements, set to an empty array
            }
        } catch (error) {
            console.error('Error fetching agreements:', error);
            setIsError(true);
            toast.error('Failed to load power purchase agreements');
        } finally {
            setLoading(false);
        }
    };

    const submitChargingPartner = async (chargingPartnerUuid: string, chargingPartnerBusinessName: string, rowId: any, workflowState: string, businessCategory: string, canOfferCharging: boolean, canRequestCharging: boolean, partnershipRequestType: string) => {
        navigate("/share/business/charging-partners/request", {
            state: {
                chargingPartnerUuid: chargingPartnerUuid,
                chargingPartnerBusinessName: chargingPartnerBusinessName,
                businessCategory: businessCategory,
                canOfferCharging: canOfferCharging,
                canRequestCharging: canRequestCharging,
                workflowState: workflowState,
                partnershipRequestType: partnershipRequestType,
            },
        })
    };

    useEffect(() => {
        fetchAgreements();
    }, []);
    return (
        <>
            {loading ? (
                <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
                    <CircularProgress />
                </Box>
            ) : (
                <div>
                    <PowerPurchaseAgreementTable agreements={agreements} />
                </div>
            )}
        </>
    );
}

export default PowerPurchaseAgreementListPage;
